import { render, staticRenderFns } from "./flex-dialog-comp.vue?vue&type=template&id=84426de6&scoped=true&"
import script from "./flex-dialog-comp.vue?vue&type=script&lang=js&"
export * from "./flex-dialog-comp.vue?vue&type=script&lang=js&"
import style0 from "./flex-dialog-comp.vue?vue&type=style&index=0&id=84426de6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84426de6",
  null
  
)

export default component.exports